import styled from 'styled-components';

export const Div = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  border-top: 1px solid ${({ theme }) => theme.colors.stroke};
  border-left: 1px solid ${({ theme }) => theme.colors.stroke};
  background-color: ${({ theme }) => theme.colors.cultured};

  .grid-block {
    display: flex;
    padding: 4px 12px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.stroke};
    border-right: 1px solid ${({ theme }) => theme.colors.stroke};
    display: inline-block;
    word-break: break-word;

    .align-center {
      text-align: center;
    }
  }
`;
